import type { PopularSearchesXStoreModule } from './types'
import { mergeConfig, setConfig } from '../../../store/utils/config-store.utils'
import { setStatus } from '../../../store/utils/status-store.utils'
import {
  cancelFetchAndSaveSuggestions,
  fetchAndSaveSuggestions,
} from './actions/fetch-and-save-suggestions.action'
import { fetchSuggestions } from './actions/fetch-suggestions.action'
import { popularSearches } from './getters/popular-searches.getter'
import { request } from './getters/request.getter'

/**
 * {@link XStoreModule} For the next-queries module.
 *
 * @internal
 */
export const popularSearchesXStoreModule: PopularSearchesXStoreModule = {
  state: () => ({
    popularSearches: [],
    searchedQueries: [],
    status: 'initial',
    config: {
      hideSessionQueries: true,
      maxItemsToRequest: 20,
    },
    params: {},
  }),
  getters: {
    request,
    popularSearches,
  },
  mutations: {
    setSuggestions(state, suggestions) {
      state.popularSearches = suggestions
    },
    setSearchedQueries(state, searchedQueries) {
      state.searchedQueries = searchedQueries
    },
    setParams(state, params) {
      state.params = params
    },
    setStatus,
    setConfig,
    mergeConfig,
  },
  actions: {
    cancelFetchAndSaveSuggestions,
    fetchSuggestions,
    fetchAndSaveSuggestions,
  },
}
